import type { ChartFormatters } from '@/shared/charts/renderers/echarts/time-series-chart/types/ChartFormatters.types';
import { html, toHtmlString } from '@/shared/charts/renderers/echarts/time-series-chart/utils/html';

import type { TooltipCard } from './TooltipCard.types';

import styles from './timeSeriesChartTooltip.module.css';

function formatValue({ value, unit }: TooltipCard, formatters: ChartFormatters) {
  const formatted = formatters.value.format(value);

  return unit ? `${formatted} ${unit}` : formatted;
}

function renderCard(card: TooltipCard, formatters: ChartFormatters) {
  const borderStyle = card.color ? `border-color:${card.color}` : '';

  return html`
    <div class="${styles.card}" style="${borderStyle}">
      <div class="${styles.value}">${formatValue(card, formatters)}</div>
      <div class="${styles.meta}">${formatters.dateTime.format(card.timestamp)}</div>
      <div class="${styles.meta}">${card.label}</div>
    </div>
  `;
}

/** Plain HTML for the ECharts tooltip formatter; every card value goes through the escaping `html` tag. */
export function renderTooltipCards(cards: TooltipCard[], formatters: ChartFormatters): string {
  if (cards.length === 0) {
    return '';
  }

  return toHtmlString(
    html`<div class="${styles.container}">${cards.map((card) => renderCard(card, formatters))}</div>`
  );
}
